import potraitGallery from 'html/customize/potrait-gallery.html';
import App from 'app/app.js';
import 'app/directive/LtPotraitGalleryCtrl.js';

function LtPotraitGalleryDirective() {
  return {
    restrict: 'E',
    scope: {
      changeLook: '&',
      choosedLook: '='
    },
    template: potraitGallery,
    controller: 'LtPotraitGalleryCtrl',
    controllerAs: 'LtPotraitGalleryCtrl'
  };
}

App.directive('ltPotraitGallery', [LtPotraitGalleryDirective]);
